import { useState } from 'react';
import cn from 'classnames';
import { UseRefinementListProps, useRefinementList } from 'react-instantsearch';

import { RefinementListItem } from 'instantsearch.js/es/connectors/refinement-list/connectRefinementList';
import { useTranslation } from 'next-i18next';
import { refinementListClassNames } from '../refinementListClassNames';
import Cookies from 'js-cookie';
import ClothingSizePanelContainer from './ClothingSizePanelContainer';
import useClothingSizeSorter from './hooks/useClothingSizeSorter';
import useSizeGroups from './hooks/useSizeGroups';

export const CLOTHING_SIZE_GROUP_DELIMITER = '_';

export const extractGroupFromLabel = (arr: RefinementListItem[]) =>
  arr.map((item) => {
    const [group, label] = item.label.split(CLOTHING_SIZE_GROUP_DELIMITER);
    return {
      ...item,
      label: label ?? item.label,
      group,
    };
  });

const ClothingSizeRefinement = (
  props: UseRefinementListProps & { locale?: string }
) => {
  const [debugAlgoliaAttribute] = useState(() =>
    Cookies.get('debugAlgoliaClothingSizeAttribute')
  );
  const customSort = useClothingSizeSorter(
    props.attribute === debugAlgoliaAttribute,
    props.locale
  );

  const { items, refine, canToggleShowMore, isShowingMore, toggleShowMore } =
    useRefinementList({
      ...props,
      limit: 6,
      showMore: true,
      showMoreLimit: 1000,
      operator: 'or',
      transformItems: extractGroupFromLabel,
      sortBy: customSort,
    });

  const { t } = useTranslation(['searchResults']);

  const sizeGroups = useSizeGroups(
    items as Array<RefinementListItem & { group: string }>
  );

  return (
    <div
      className={cn(refinementListClassNames.root, {
        [refinementListClassNames.noRefinementRoot]: items.length === 0,
      })}
    >
      <ul className={refinementListClassNames.list}>
        {sizeGroups.map((group) => (
          <ClothingSizePanelContainer
            refinementName={props.attribute}
            group={group}
            items={(
              items as Array<RefinementListItem & { group: string }>
            ).filter((item) => item.group === group)}
            refine={refine}
            key={group}
          />
        ))}
      </ul>
      {canToggleShowMore && (
        <button
          onClick={() => {
            toggleShowMore();
          }}
          className={refinementListClassNames?.showMore}
        >
          {isShowingMore ? t('search.showless') : t('search.showmore')}
        </button>
      )}
    </div>
  );
};

export default ClothingSizeRefinement;
